import * as KEY from '@/constants/keyCode';

const createHandler = (container) => (event) => {
	if (event.keyCode !== KEY.TAB) {
		return;
	}

	const focusableElems = container.querySelectorAll(
		'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
	);

	const firstElem = focusableElems[0];
	const lastElem = focusableElems[focusableElems.length - 1];

	if (!event.shiftKey && document.activeElement === lastElem) {
		event.preventDefault();
		firstElem.focus();
	}

	if (event.shiftKey && document.activeElement === firstElem) {
		event.preventDefault();
		lastElem.focus();
	}
};

const subscribe = (rootRef) => {
	const handler = createHandler(rootRef.current);

	document.addEventListener('keydown', handler);

	return () => {
		document.removeEventListener('keydown', handler);
	};
};

export default subscribe;

